import React, { useMemo } from "react";
import {
  DevToolsProvider,
  sitesPlugin,
  amplitudePlugin,
  autofillPlugin,
  envHealthPlugin,
  skipToQcpPlugin,
  tracesPlugin,
  idmPlugin,
} from "components/devtools";

interface Site {
  name: string;
  description: string;
  href: string;
}

interface Variant {
  key: string;
  value: string;
  isControl: boolean;
  isActive: boolean;
}

interface Experiment {
  name: string;
  label: string;
  variants: Variant[];
  hasActiveVariant: boolean;
}

interface DevToolsProps {
  // From DevToolsViewModel
  mainSites: Site[];
  ukSites: Site[];
  usSites: Site[];
  verticals: Record<string, string>;
  domainUserId?: string;
  currentSite: string;
  journeyId?: string;
  verticalForIdmRequest?: string;
  amplitudeExperiments: string[];
  amplitudeExperimentsDetailed?: {
    currentPage: Experiment[];
    allOthers: Experiment[];
  };
  // From AutoFillViewModel
  answerSets?: Record<string, [string, string][]>;
  site?: string;
  fillJourneyAnswersPath?: string;
  fillCustomJourneyAnswersPath?: string;
}

function DevTools(props: DevToolsProps) {
  const plugins = useMemo(
    () => [
      sitesPlugin({
        mainSites: props.mainSites || [],
        ukSites: props.ukSites || [],
        usSites: props.usSites || [],
        verticals: props.verticals || {},
      }),
      autofillPlugin({
        journeyId: props.journeyId,
        site: props.site || props.currentSite,
        answerSets: props.answerSets,
        fillJourneyAnswersPath: props.fillJourneyAnswersPath,
        fillCustomJourneyAnswersPath: props.fillCustomJourneyAnswersPath,
      }),
      skipToQcpPlugin(),
      amplitudePlugin({
        domainUserId: props.domainUserId,
        experiments: props.amplitudeExperiments || [],
        currentSite: props.currentSite || "",
        amplitudeExperimentsDetailed: props.amplitudeExperimentsDetailed,
      }),
      envHealthPlugin(),
      tracesPlugin(),
      idmPlugin({
        domainUserId: props.domainUserId,
        currentSite: props.currentSite,
        journeyId: props.journeyId,
        verticalForIdmRequest: props.verticalForIdmRequest?.toLowerCase(),
      }),
    ],
    // Props come from server-rendered data and don't change within a page lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <DevToolsProvider plugins={plugins} />;
}

export default DevTools;
